var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCautioninline = function SvgCautioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 10A8.333 8.333 0 0 1 10 18.332a8.333 8.333 0 0 1-8.333-8.334c0-4.6 3.731-8.333 8.333-8.333a8.335 8.335 0 0 1 8.333 8.333ZM10 11.68a1.546 1.546 0 1 0 0 3.09 1.546 1.546 0 0 0 0-3.09Zm-1.218-.987-.25-4.57a.403.403 0 0 1 .403-.425h2.13c.231 0 .415.194.403.425l-.25 4.57a.403.403 0 0 1-.402.382H9.184a.403.403 0 0 1-.402-.382Z",
    fill: "#FFC507"
  })));
};
export default SvgCautioninline;